export const mutedTrackColors = [
    '#FFF011', // light yellow
    '#A4A4A4', // grey
    '#000000', // black
    '#DCEE0E', // yellow-green
    '#FFC900', // yellow-orange
    '#8AD42F', // lime
    '#784D3E', // mocha
];

export const boldTrackColors = [
    '#F42410',  // dark red
    '#F90553',  // pink

    '#B60DC3', // purple
    '#5E23CA', // dark purple
    '#2D3FC7', // dark blue

    '#0498FF', // light blue
    '#00ACF8', // ligher blue
    '#00C3DD', // cyan

    '#009B89', // teal
    '#36C03B', // dark green

    '#FF9D00', // orange
    '#FF4D04', // red

    '#577B8E', // steelblue
];

export default [...mutedTrackColors, ...boldTrackColors];
